/**
 * Single-segment root paths: public documents (privacy, data-deletion, terms, credits,
 * about, support) or redirect to /. Slugs are allowlisted in legalRootSlug.helper.
 *
 * generateStaticParams makes Expo emit one HTML file per slug at export time, so each
 * document is a real crawlable page rather than a shared SPA shell.
 */

import { Redirect, useLocalSearchParams, usePathname } from 'expo-router'
import { LegalDocumentScreen } from '../components/landing/LegalDocumentScreen/LegalDocumentScreen'
import {
  getAllLegalDocumentSlugs,
  getLegalDocumentVariantForSlug,
  normalizeRootSlugParam,
} from '../src/landing/helpers/legalRootSlug.helper'

export function generateStaticParams(): Array<{ slug: string }> {
  return getAllLegalDocumentSlugs().map((slug) => ({ slug }))
}

export default function RootSlugRoute() {
  const params = useLocalSearchParams<{ slug?: string | string[] }>()
  const pathname = usePathname()
  // Route params are not populated during static export, so fall back to the pathname —
  // otherwise every document would render the redirect branch and export an empty page.
  const slug =
    normalizeRootSlugParam(params.slug) || pathname.replace(/^\/+|\/+$/g, '')
  const variant = getLegalDocumentVariantForSlug(slug)

  if (variant !== null) {
    return <LegalDocumentScreen variant={variant} slug={slug} />
  }

  return <Redirect href="/" />
}
